import MenuCard from './components/MenuCard';

function App() {
  return <MenuCard />;
}

export default App;
